import { reactiveVars } from '@brainpool/apollo-connect';
import Button from '@brainpool/components/atoms/Button/Button';
import { Delete, Share } from '@brainpool/icon-pack';
import { Case } from '../../../types/Case';
import { ModalProps } from '../../../types/ModalTypes';
import { Box, Stack, Typography, useTheme } from '@mui/material';

export interface BulkActionsProps {
  data: Partial<Case>[];
  onClose: () => void;
}

export function BulkActions({ data, onClose }: BulkActionsProps) {
  const theme = useTheme();

  const handleOpenModal = (type: ModalProps['type']) => {
    reactiveVars.modalData({
      data,
      type,
      open: true,
      onClose: () => ({ open: false }),
    });
  };

  if (data.length <= 1) {
    return null;
  }
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 2,
        justifyContent: 'space-between',
        alignItems: 'center',
        px: 2,
        py: 1,
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
      }}
    >
      <Typography variant="body1">{data.length} Projects selected</Typography>

      <Stack direction="row" spacing={2}>
        <Button
          variant="contained"
          data-testid="delete-projects-button"
          onClick={() => {
            handleOpenModal('delete');
          }}
        >
          <Typography sx={{ pr: 2 }}>Delete</Typography>
          <Delete size={16} fill={theme.palette.text.primary} />
        </Button>

        <Button
          variant="contained"
          data-testid="share-projects-button"
          onClick={() => {
            handleOpenModal('share');
          }}
        >
          <Typography sx={{ pr: 2 }}>Share</Typography>
          <Share size={16} fill={theme.palette.text.primary} />
        </Button>

        <Button variant="contained" onClick={onClose} sx={{ borderLeft: 'solid 1px' }}>
          <Typography sx={{ pr: 2 }}>Close</Typography>
        </Button>
      </Stack>
    </Box>
  );
}
export default BulkActions;
